import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class DeskWallToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {
    public map(element: Element): ISimpleSapElement[] {
        const type = this.formatType('PTB', 7, 1);
        const color = this.toColor(element);
        return [SimpleSapElement.ELEMENT(type, color)];
    }
}
